import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * Add one of Shopify Search & Discovery's recommended variants to the native cart.
 * The same cart-lines event and section rendering contract as Horizon product-form is used.
 */
if (!window.__hbProductPairBound) {
  window.__hbProductPairBound = true;

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('.hb-product-pair [data-pair-variant]');
    if (!input || input.tagName !== 'SELECT') return;
    const card = input.closest('.hb-product-pair__card');
    const option = input.selectedOptions[0];
    const price = card?.querySelector('[data-pair-current]');
    const compare = card?.querySelector('[data-pair-compare]');
    const button = card?.querySelector('[data-pair-add]');
    const available = option.dataset.available === 'true';
    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (button) {
      button.disabled = !available;
      button.textContent = available ? 'Add' : 'Sold out';
    }
    if (card) card.querySelector('.hb-product-pair__status').textContent = '';
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('.hb-product-pair [data-pair-add]');
    if (!button || button.disabled) return;
    const card = button.closest('.hb-product-pair__card');
    const input = card?.querySelector('[data-pair-variant]');
    const variantId = input?.value;
    if (!variantId || button.disabled) return;

    const live = card.querySelector('.hb-product-pair__status');
    const original = button.textContent;
    const root = window.Shopify?.routes?.root || '/';
    const cartUrl = `${root}cart/add.js`;
    const cartStateUrl = `${root}cart.js`;
    const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((el) => el.dataset.sectionId).filter(Boolean);

    button.disabled = true;
    button.textContent = 'Adding…';
    live.textContent = '';
    const deferred = CartLinesUpdateEvent.createPromise();
    card.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    }));

    try {
      const response = await fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sections.join(',') }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add item');
      const cartResponse = await fetch(cartStateUrl, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Unable to refresh cart');
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'hb-product-pair',
          sourceId: card.dataset.productId,
          productId: card.dataset.productId,
          itemCount: 1,
          didError: false,
          sections: data.sections,
        },
      });
      live.textContent = 'Added to cart';
    } catch (error) {
      deferred.reject(error);
      card.dispatchEvent(new CartErrorEvent({ error: error.message || 'Unable to add item', code: 'INVALID' }));
      live.textContent = error.message || 'Unable to add item';
    } finally {
      const available = input?.tagName === 'SELECT'
        ? input.selectedOptions[0]?.dataset.available !== 'false'
        : input?.dataset.available !== 'false';
      button.disabled = !available;
      button.textContent = available ? original : 'Sold out';
    }
  });
}
